import { Link } from 'react-router-dom';
import { castList } from '@/mocks/siteData';
import CastCard from '@/components/feature/CastCard';

export default function CastPreview() {
  const preview = castList.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div>
          <div className="flex items-center gap-3 mb-2">
            <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
            <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl">
              主要演员
            </h2>
          </div>
          <p className="text-sm text-foreground-500">认识《善良的小姨子》里的每一张熟悉面孔</p>
        </div>
        <Link
          to="/category/cast"
          className="hidden sm:inline-flex items-center gap-1 px-4 py-2 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-accent-400 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          全部演员
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {preview.map((member) => (
          <CastCard key={member.id} member={member} />
        ))}
      </div>
    </section>
  );
}